exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dataTip[data-v-1fa2b7d4]{float:right;font-size:12px;color:#1890ff}.dataTip i[data-v-1fa2b7d4]{margin-left:5px}\n", ""]);

// exports
